import Cookies from 'js-cookie'

const TokenKey = 'live_center_token'
const refTokenKey = 'live_center_reftoken'
const loginDate = 'live_center_loginDate'
const expiresDate = 'live_center_expiresDate'
const userInfo = 'live_center_userInfo'
const accountId = 'live_center_accountId'
const studentId = 'live_center_studentId'

export function getAccountId() {
    return Cookies.get(accountId)
}

export function setAccountId(token) {
    return Cookies.set(accountId, token)
}

export function removeAccountId() {
    return Cookies.remove(accountId)
}

export function getStudentId() {
    return Cookies.get(studentId)
}

export function setStudentId(token) {
    return Cookies.set(studentId, token)
}

export function removeStudentId() {
    return Cookies.remove(studentId)
}

export function getToken() {
    return Cookies.get(TokenKey)
}

export function setToken(token) {
    return Cookies.set(TokenKey, token)
}

export function removeToken() {
    return Cookies.remove(TokenKey)
}

export function getrefToken() {
    return Cookies.get(refTokenKey)
}

export function setrefToken(reftoken) {
    return Cookies.set(refTokenKey, reftoken)
}

export function removerefToken() {
    return Cookies.remove(refTokenKey)
}

export function getloginTime() {
    return Cookies.get(loginDate)
  }

export function setloginTime(loginTime) {
    return Cookies.set(loginDate, loginTime)
}

export function removeloginTime() {
    return Cookies.remove(loginDate)
}

export function getExpiresTime() {
    return Cookies.get(expiresDate)
  }

export function setExpires(expiresTime) {
    return Cookies.set(expiresDate, expiresTime)
}

export function removeExpiresTime() {
    return Cookies.remove(expiresDate)
}

export function getuserInfo() {
    return Cookies.get(userInfo)
  }

export function setuserInfo(info) {
    return Cookies.set(userInfo, info)
}

export function removeuserInfo() {
    return Cookies.remove(userInfo)
}
